import { useQuery } from '@tanstack/react-query'
import { UserAvatarProxy } from '../api'
import { userQueryKeys } from '../config/query-keys'

export const useCurrentAvatar = (enabled: boolean = true) => {
	return useQuery({
		queryKey: userQueryKeys.currentAvatar,
		queryFn: UserAvatarProxy.getCurrentAvatar,
		enabled,
		staleTime: Infinity,
		cacheTime: Infinity,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		retry: false,
	})
}
